import { ShippingMethodList, ShippingMethodEdit } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

const name = 'shippingMethod';

const icon = 'fa-dolly';

export default {
    pages: {
        ShippingMethodList,
        ShippingMethodEdit,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name,
    icon,
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/ShippingMethod/index.ts